import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ResidencePage from './views/ResidencePage.vue';
import UrlBuilder from './views/UrlBuilder.vue';
import Comparison from './views/Comparison.vue';

Vue.use(Router);

//export default new Router({
const routes = [
  {
    path: '/',
    publicPath: '/',
    name: 'Boligvelger',
    component: Home,
  },
  {
    path: '/bolig/:slug',
    publicPath: '/',
    name: 'bolig',
    component: ResidencePage,
    meta: {
      scrollToTop: true,
    },
  },
  {
    path: '/urlbuilder/',
    publicPath: '/',
    name: 'URL Builder',
    component: UrlBuilder,
  },
  {
    path: '/comparison/',
    name: 'Comparison',
    component: Comparison,
  },
];

const router = new Router({
  routes,
});

export default router;
